import { gql } from '../__generated__'

export const SEARCH_THREADS = gql(`
  query SearchThreads($input: SearchThreadsInput!) {
    searchThreads(input: $input) {
      threads {
        ...ThreadInfoFragment
      }
      meta {
        ...PaginationMetadataFragment
      }
    }
  }
`)

export const SEARCH_RECENT_ACTIVITY_THREADS = gql(`
  query SearchRecentActivityThreads($pageRequest: PageRequestInput!, $unreadOnly: Boolean!) {
    recentThreads(pageRequest: $pageRequest, unreadOnly: $unreadOnly) {
      activities {
        ... on ThreadCommentActivity {
            thread {
                ...ThreadInfoFragment
            }
            recentParticipants {
                ...AccountFragment
            }
            lastParticipant {
                ...AccountFragment
            }
            time {
                ...TimestampFragment
            }
        }
        ... on ThreadLikeActivity {
            accounts {
              ...AccountFragment
            }
            comment {
              ...CommentFragment
              thread {
                id
                title
                alias
                lastReadTime {
                  ...TimestampFragment
               }
              }
            }
            time {
              ...TimestampFragment
            }
          }
        ... on ThreadGoalActivity {
            isTerminal
            goal {
              id
              name
            }
            thread {
              id
              title
              alias
              unreadCommentCount
              lastReadTime {
                ...TimestampFragment
             }
            }
            convertedBy {
              ...AccountFragment
            }
            createdAt {
              ...TimestampFragment
            }
          }
        ... on ThreadTaskActivity {
            isTerminal
            task {
              id
              name
              parentEntityType
            }
            thread {
              id
              title
              alias
              unreadCommentCount
              lastReadTime {
                ...TimestampFragment
             }
            }
            convertedBy {
              ...AccountFragment
            }
            createdAt {
              ...TimestampFragment
            }
          }
        }
      meta {
        ...PaginationMetadataFragment
      }
    }
  }
`)

export const GET_THREAD = gql(`
  query GetThread($threadId: UUID!) {
    getThread(id: $threadId) {
      ...ThreadFragment
    }
  }
`)

export const GET_THREAD_COMMENTS = gql(`
  query GetThreadComments($threadId: UUID!, $pageRequest: PageRequestInput!) {
    getThreadComments: getThread(id: $threadId) {
      id
      comments(pageRequest: $pageRequest) {
        ...CommentFragment
      }
    }
  }
`)

export const GET_THREAD_COUNTERS = gql(`
    query GetThreadCounters {
      threadCounters {
      drafts
      favourites
      unread
      reminders
    }
  }
`)

export const GET_FAVOURITE_THREADS = gql(`
  query GetFavouriteThreads {
    favouriteThreads {
      ...ThreadFavouriteFragment
    }
  }
`)

export const GET_THREAD_DRAFTS = gql(`
  query AllThreadDrafts {
    allThreadDrafts {
      ...ThreadDraftInfoFragment
    }
  }
`)

export const GET_DRAFT = gql(`
  query GetThreadDraft($draftId: UUID!) {
    getThreadDraft(id: $draftId) {
      ...ThreadDraftFragment
    }
  }
`)
